import { useFeatureFlags } from "~/contexts/featureFlagProvider";
import {
  isVariablePackagesOnLotDefaultEnabled,
  isWorkOrderV1DefaultEnabled,
  isWorkOrderV2DefaultEnabled,
  variablePackagesOnLotEnabled,
  workOrderV1Enabled,
  workOrderV2Enabled,
} from "~/shared/constants/feature-flag.constants";
import { applyWorkOrderFlagOverrides, type WorkOrderFlags } from "~/shared/constants/work-order-flags";

/**
 * UI-side counterpart to `resolveWorkOrderFlags`, sharing the same coercion rules so navigation
 * and entry points cannot disagree with the server guards. Cosmetic — the server guard is
 * authoritative.
 */
export const useWorkOrderFlags = (): WorkOrderFlags => {
  const { getFeatureFlag } = useFeatureFlags();

  return applyWorkOrderFlagOverrides({
    wov1: getFeatureFlag(workOrderV1Enabled, isWorkOrderV1DefaultEnabled()),
    wov2: getFeatureFlag(workOrderV2Enabled, isWorkOrderV2DefaultEnabled()),
    variablePackagesOnLot: getFeatureFlag(variablePackagesOnLotEnabled, isVariablePackagesOnLotDefaultEnabled()),
  });
};
